import {ClockHandsIcon} from '@github-ui/custom-icons/ClockHandsIcon'
import {OverviewMergeControl} from './shared/OverviewMergeControl'
import {OverviewUpdateBranchControl} from './shared/OverviewUpdateBranchControl'
import {isForYouRefreshEnabled} from '../shared/for-you-feature-flags'
import {useId} from 'react'
import {ForYouItem} from '../shared/ForYouItem'
import {decideChecksItem} from './shared/checks-item-decider'
import {useMergeabilityData} from './use-mergeability-data'
import {WorkflowApprovalSubtitle} from '@github-ui/mergebox/components/sections/checks/WorkflowApprovalSubtitle'
import {usePullRequestAnalytics} from '../../../../hooks/use-pull-request-analytics'
import styles from '../shared/ForYouItem.module.css'
import {useForYouActionErrors} from '../shared/use-for-you-action-errors'

// Renders when workflow runs are awaiting approval but the viewer cannot approve them.
// Shows the approval message without the approve action.
export function AwaitingApprovalChecks() {
  const {onUpdateBranchError, onQueueError, footer} = useForYouActionErrors()
  const data = useMergeabilityData()
  const {sendPullRequestAnalyticsEvent} = usePullRequestAnalytics()
  const descriptionId = useId()

  const decision = decideChecksItem(data)
  if (!data || decision.kind !== 'awaiting-approval') {
    return null
  }

  const {workflowApproval} = decision

  return (
    <ForYouItem
      itemId="pending-checks"
      footer={footer}
      visual={{kind: 'icon', icon: ClockHandsIcon, tone: 'attention', glyphSize: 24}}
      title="Some checks need approval"
      subText={
        <div id={descriptionId}>
          <WorkflowApprovalSubtitle
            pendingWorkflowApprovalRollup={workflowApproval}
            className={styles.description}
            onClick={() =>
              sendPullRequestAnalyticsEvent('overview.for_you_item_action', 'OVERVIEW_FOR_YOU_ITEM', {
                item_name: 'pending-checks',
                action_name: 'learn_about_approving_workflows',
              })
            }
          />
        </div>
      }
      actions={[
        {
          id: 'update-branch',
          content: isForYouRefreshEnabled() ? (
            <OverviewUpdateBranchControl itemName="pending-checks" onError={onUpdateBranchError} />
          ) : null,
        },
        {
          id: 'merge-control',
          content: <OverviewMergeControl data={data} itemName="pending-checks" onQueueError={onQueueError} />,
        },
      ]}
    />
  )
}
